import { gql } from '@apollo/client'
import { Button, Modal } from '@farol-ds/react'
import { ReactNode } from 'react'

import { useModalContext } from '../context'
import { InconsistentPlanLockModalLock_OfferLockDataFragment } from './__generated__/modal-lock.graphql'
import styles from './inconsistent-plan-lock.module.scss'

interface ModalWrapperProps {
  offerLockData: InconsistentPlanLockModalLock_OfferLockDataFragment
  children: ReactNode
}

export const ModalLock = ({ offerLockData, children }: ModalWrapperProps) => {
  const { open, setOpen } = useModalContext()
  if (!offerLockData.body.cards.length) {
    return null
  }

  const [card] = offerLockData.body.cards
  const button = card.button

  return (
    <Modal size="sm" open={open} onOpenChange={setOpen}>
      <Modal.Content>
        <Modal.IconClose />

        <Modal.Body className={styles.body}>{children}</Modal.Body>

        <Modal.Footer>
          <Button kind="primary" asChild>
            <a href={button.url} target="_blank" rel="noopener noreferrer">
              {button.label}
            </a>
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}

ModalLock.fragments = {
  offerLockData: gql`
    fragment InconsistentPlanLockModalLock_offerLockData on OfferLockData {
      body {
        cards {
          button {
            label
            url
          }
        }
      }
    }
  `,
}
